export default "__VITE_PUBLIC_ASSET__1d720fa9__"